import Vue from 'vue';

Vue.component('card-tooltip-component', {
    data() {
        return {
            isTooltipDisclaimerVisible: false,
        };
    },

    methods: {
        toggleDisclaimerTooltip() {
            this.isTooltipDisclaimerVisible = !this.isTooltipDisclaimerVisible;
        },

        handleTooltipKeydown(event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.stopPropagation();
                this.isTooltipDisclaimerVisible =
                    !this.isTooltipDisclaimerVisible;
            }
        },
    },
});
